var _rect, _rect2, _path, _path2, _rect3, _path3, _rect4, _rect5, _rect6, _rect7, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 25,
    width: 23,
    height: 13,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 18,
    width: 27,
    height: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4998 14.0015C12.4998 16.4015 17.3332 17.0015 19.4998 17.0015C18.4997 11.5031 14.9998 9.50153 13.9998 9.00153C12.9998 8.50153 7.99985 11.0015 10.4998 14.0015Z",
    fill: "#FF8A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 13.564C27 15.964 22.1667 16.564 20 16.564C21.0002 11.0656 24.5 9.06403 25.5 8.56403C26.5 8.06403 31.5 10.564 29 13.564Z",
    fill: "#FF8A00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 18,
    width: 5,
    height: 7,
    fill: "#FF8A00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68611 25.2161H5V19.7942C5 18.2557 6.24715 17.0086 7.78559 17.0086H17.0129M7.68611 25.2161V37.2153C7.68611 37.7676 8.13382 38.2153 8.68611 38.2153H30.4134C30.9657 38.2153 31.4134 37.7676 31.4134 37.2153V25.2161M7.68611 25.2161H17.0129M31.4134 25.2161H34V19.7942C34 18.2557 32.7529 17.0086 31.2144 17.0086H22.0369M31.4134 25.2161H22.0369M17.0129 17.0086V25.2161M17.0129 17.0086H19.5249M17.0129 25.2161H22.0369M22.0369 17.0086V25.2161M22.0369 17.0086H19.5249M19.5249 17.0086C19.0192 14.3391 17.1124 9 13.5309 9C9.05403 9 6.86535 17.0086 19.5249 17.0086ZM19.5249 17.0086C20.0555 14.3391 22.1463 9 26.265 9C31.4134 9 29.6973 17.0086 19.5249 17.0086Z",
    stroke: "black",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.6107,
    y: 5.31836,
    width: 1,
    height: 3,
    transform: "rotate(-45 35.6107 5.31836)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5604,
    y: 10.2676,
    width: 1,
    height: 3,
    transform: "rotate(-45 40.5604 10.2676)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 42.6818,
    y: 4.61133,
    width: 1,
    height: 3,
    transform: "rotate(45 42.6818 4.61133)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 37.7321,
    y: 9.56055,
    width: 1,
    height: 3,
    transform: "rotate(45 37.7321 9.56055)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 8.5,
    r: 1.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/rewards.eb6bf9f90163493854947a7e6b1b626b.svg";
export { ForwardRef as ReactComponent };